import React from "react";
import styles from "./TopicsPreview.module.scss";
import Form from "../../../../common/forms/Form";
import BackBar from "../../../../common/nav/BackBar";
import SingleTopics from "../../../topic-single/SingleTopics";
import SaveButton from "../../../../common/nav/SaveButton";
import { OutputData } from "@editorjs/editorjs";
import { SonicTermData } from "../../../../common/classes/SonicTerm";

type Props = {
  title?: string;
  mainImg?: string;
  type?: string;
  startDate?: number;
  game?: Array<SonicTermData>;
  tags?: Array<string>;
  article?: OutputData;
  authorName?: string;
  handler: () => void;
  handlePrivate?: () => void;
  handleSubmit?: () => void;
  handleSave?: () => void;
};
const TopicsPreview: React.FC<Props> = ({
  title,
  mainImg,
  type,
  startDate,
  game,
  tags,
  article,
  authorName,
  handler,
  handlePrivate,
  handleSubmit,
  handleSave,
}) => {
  return (
    <>
      <BackBar
        title={"プレビュー確認"}
        editable={false}
        handleClose={handler}
      />
      <Form handler={() => {}}>
        <div className={styles["topics-preview"]}>
          <div className={styles["topics-preview__contents"]}>
            <SingleTopics
              type={type}
              date={startDate}
              title={title}
              imgSrc={mainImg}
              game={game}
              tags={tags}
              content={article?.blocks}
              authorName={authorName}
              isPreview={true}
            />
          </div>
        </div>
        {handlePrivate ? (
          <SaveButton
            title="非公開で保存"
            onClick={handlePrivate}
            type={"neon-blue"}
          />
        ) : null}
        {handleSave ? <SaveButton title="保存" onClick={handleSave} /> : null}
        {handleSubmit ? (
          <SaveButton title="公開申請" onClick={handleSubmit} />
        ) : null}
      </Form>
    </>
  );
};

export default TopicsPreview;
